import { Committee, User } from '@/types';
import {
  DataTableColumnBadgeProps,
  DataTableColumnTextProps,
  DataTableColumnVariant,
  DataTableRowActions,
  DataTableVariant,
  DynamicDataTable,
  DynamicDataTableColumn,
  DataTableServerQuery,
} from '@/components/data-table-builder/data-table.types';
import { CommitteeRepository } from '@/store/committee-state/committee-state.repository';

interface getCommitteeDataTableStructureProps {
  store: CommitteeRepository;
  createAction?: () => void;
  rowActions?: DataTableRowActions;
  rowActionsFn?: (row: Committee) => DataTableRowActions;
  serverQuery?: DataTableServerQuery;
}

export const getCommitteeDataTableStructure = ({
  store,
  createAction,
  rowActions,
  rowActionsFn,
  serverQuery,
}: getCommitteeDataTableStructureProps): DynamicDataTable => {
  const idColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.committee.table.id',
    accessorKey: 'id',
    variant: DataTableColumnVariant.TEXT,
  };
  const nameColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.committee.table.name',
    accessorKey: 'nom',
    variant: DataTableColumnVariant.TEXT,
  };
  const decretColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.committee.table.decretCreation',
    accessorKey: 'decretCreation',
    variant: DataTableColumnVariant.TEXT,
  };
  // const responsableColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
  //   label: 'settings.committee.table.responsable',
  //   accessorKey: 'responsable',
  //   variant: DataTableColumnVariant.TEXT,
  // };
  const specialColumn: DynamicDataTableColumn<DataTableColumnBadgeProps> = {
    label: 'settings.committee.table.special',
    accessorKey: 'special',
    variant: DataTableColumnVariant.BADGE,
    renderAs: (value: boolean) => {
      return { value: value === true ? 'OUI' : 'NON' };
    },
    props: {
      innerClass: 'px-3 py-1',
      getSeverity: (value: boolean) => {
        return value === true ? 'success' : 'danger';
      },
    },
  };
  const ancrageColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.committee.table.ancrage',
    accessorKey: 'tutel.nom',
    variant: DataTableColumnVariant.TEXT,
  };
  const committeType: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.committee.table.committeeType',
    accessorKey: 'comType.description',
    variant: DataTableColumnVariant.TEXT,
  };

  return {
    data: [],
    singular: 'settings.committee.table.singular',
    plural: 'settings.committee.table.plural',
    columns: [idColumn, nameColumn, decretColumn, specialColumn, ancrageColumn, committeType],
    variant: DataTableVariant.COMMON,
    sizes: [10, 20, 50],
    stripedRows: true,
    enableServerActions: true,
    serverQuery,
    target: row => {
      store.set('dto', {
        nom: row.nom,
        decretCreation: row.decretCreation,
        responsableId: row.responsableId,
        userIds: row.users?.map((user: User) => user.id),
        special: row.special,
        ancrage: row.ancrage,
        adresse: row.adresse,
        comTypeId: row.comType.id,
        tutelId: row.tutel?.id || null,
      });
      store.set('response', row);
      store.set('comTypeIdSelected', { code: row.comType.id, name: row.comType.description });
      if (row.tutel) {
        store.set('tuttelSelected', { name: row.tutel.nom, code: row.tutel.id });
      }
    },
    createAction,
    rowActions,
    rowActionsFn,
    searchableFields: ['id', 'nom', 'decretCreation', 'responsable', 'special', 'ancrage', 'comType.description'],
  };
};
